const events = {
    'menu.open': {
        category: 'Menu',
        action: 'Abrir',
    },
    'menu.close': {
        category: 'Menu',
        action: 'Cerrar',
    },
    'menu.closeIcon': {
        category: 'Menu',
        action: 'Cerrar (ícono)',
    },
    'menu.closeOverlay': {
        category: 'Menu',
        action: 'Cerrar (overlay)',
    },
    'menu.click': (item) => ({
        category: 'Menu',
        action: 'Click',
        label: item.label,
    }),

    'loginRequest.accept.prompt': {
        category: 'Solicitud de login',
        action: 'Aceptar',
        label: 'Sugerencia',
    },
    'loginRequest.reject.prompt': {
        category: 'Solicitud de login',
        action: 'Rechazar',
        label: 'Sugerencia',
    },
    'loginRequest.close.prompt': {
        category: 'Solicitud de login',
        action: 'Cerrar',
        label: 'Sugerencia',
    },
    'loginRequest.accept.createField': {
        category: 'Solicitud de login',
        action: 'Aceptar',
        label: 'Crear lote',
    },
    'loginRequest.close.createField': {
        category: 'Solicitud de login',
        action: 'Cerrar',
        label: 'Crear lote',
    },
    'loginRequest.accept.createSeason': {
        category: 'Solicitud de login',
        action: 'Aceptar',
        label: 'Guardar recomendación',
    },
    'loginRequest.close.createSeason': {
        category: 'Solicitud de login',
        action: 'Cerrar',
        label: 'Guardar recomendación',
    },

    'tutorial.show': {
        category: 'Tutorial de instalación',
        action: 'Mostrar',
    },
    'tutorial.hide': {
        category: 'Tutorial de instalación',
        action: 'Cerrar',
    },

    share: (payload) => ({
        category: 'Social',
        action: 'Compartir',
        label: payload.provider,
    }),

    'users.signUp': {
        category: 'Usuarios',
        action: 'Crear cuenta (contraseña)',
    },
    'users.socialSignUp': {
        category: 'Usuarios',
        action: 'Crear cuenta (social)',
    },
    'users.login': {
        category: 'Usuarios',
        action: 'Login (contraseña)',
    },
    'users.socialLogin': (payload) => ({
        category: 'Usuarios',
        action: 'Login (social)',
        label: payload.provider,
    }),
    'users.invalidLogin': {
        category: 'Usuarios',
        action: 'Login inválido (contraseña)',
    },
    'users.profileUpdate': {
        category: 'Usuarios',
        action: 'Editar perfil',
    },
    'users.passwordChange': {
        category: 'Usuarios',
        action: 'Modificar contraseña',
    },
    'users.passwordReset': {
        category: 'Usuarios',
        action: 'Iniciar recuperación de contraseña',
    },
    'users.passwordResetConfirm': {
        category: 'Usuarios',
        action: 'Resetear contraseña',
    },
    'users.setCountry': {
        category: 'Usuarios',
        action: 'Cambiar país',
    },
    'users.setLanguage': {
        category: 'Usuarios',
        action: 'Cambiar idioma',
    },
    'users.setUnits': {
        category: 'Usuarios',
        action: 'Cambiar unidades',
    },
    'users.anonymous': {
        category: 'Usuarios',
        action: 'Ingresar como invitado',
    },
    'users.anonymous.createAccount': {
        category: 'Usuarios (Invitados)',
        action: 'Crear cuenta',
    },
    'users.anonymous.setCountry': {
        category: 'Usuarios (Invitados)',
        action: 'Cambiar país',
    },
    'users.anonymous.setLanguage': {
        category: 'Usuarios (Invitados)',
        action: 'Cambiar idioma',
    },
    'users.anonymous.setUnits': {
        category: 'Usuarios (Invitados)',
        action: 'Cambiar unidades',
    },
    'weedfinder.weedfinder': {
        category: 'Buscador de malezas',
        action: 'Ingreso a Buscador de Malezas',
    },
    'weedFinder.reset': {
        category: 'Buscador de malezas',
        action: 'Resetear búsqueda',
    },
    'weedFinder.viewType': (type) => ({
        category: 'Buscador de malezas',
        action: 'Cambiar visualización del listado',
        label: type === 'row' ? 'Foto pequeña' : 'Foto grande',
    }),
    'weedFinder.filter': (payload) => ({
        category: 'Buscador de malezas',
        action: `${payload.adding ? 'Agregar' : 'Remover'} filtro`,
        label: payload.label,
    }),
    'weedFinder.search': (query) => ({
        category: 'Buscador de malezas',
        action: 'Buscar por nombre',
        label: query,
    }),
    'weedDetail.changeImage': (index) => ({
        category: 'Buscador de malezas',
        action: 'Cambiar foto (detalle)',
        value: index,
    }),

    'recomendation.create.corn': {
        category: 'Recomendaciones (nueva)',
        action: 'Guardar recomendación maíz',
    },
    'recomendation.create.soy': {
        category: 'Recomendaciones (nueva)',
        action: 'Guardar recomendación soja',
    },

    'recomendation.delete': {
        category: 'Recomendaciones (guardadas)',
        action: 'Eliminar',
    },
    'recomendation.download': {
        category: 'Recomendaciones (guardadas)',
        action: 'Descargar',
    },
    'recomendation.whatsapp': {
        category: 'Recomendaciones (guardadas)',
        action: 'WhatsApp',
    },
    'recomendation.email': {
        category: 'Recomendaciones (guardadas)',
        action: 'Enviar por email',
    },

    'recomendations.expandNew': {
        category: 'Recomendaciones (listado)',
        action: 'Expandir nueva recomendación',
    },
    'recomendations.collapseNew': {
        category: 'Recomendaciones (listado)',
        action: 'Colapsar nueva recomendación',
    },

    'recomendation.create': (type) => ({
        category: 'Recomendaciones (nueva)',
        action: 'Guardar',
        label: type,
    }),
    'recomendation.back': (type) => ({
        category: 'Recomendaciones (nueva)',
        action: 'Atrás',
        label: type,
    }),
    'recomendation.recalculate': (type) => ({
        category: 'Recomendaciones (nueva)',
        action: 'Recalcular',
        label: type,
    }),
    'recomendation.field': (payload) => ({
        category: 'Recomendaciones (nueva)',
        action: 'Seleccionar lote',
        label: payload,
    }),
    'recomendation.newField': () => ({
        category: 'Recomendaciones (nueva)',
        action: 'Nuevo lote',
    }),
    'recomendation.crop': (payload) => ({
        category: 'Recomendaciones (nueva)',
        action: 'Seleccionar cultivo',
        label: payload,
    }),
    'recomendation.cornProduct': (payload) => ({
        category: 'Recomendaciones (nueva)',
        action: 'Seleccionar producto (Maíz)',
        label: payload,
    }),
    'recomendation.soyProduct': (payload) => ({
        category: 'Recomendaciones (nueva)',
        action: 'Seleccionar producto (Soja)',
        label: payload,
    }),
    'recomendation.scheduledPlantingDate': (payload) => ({
        category: 'Recomendaciones (nueva)',
        action: 'Seleccionar fecha de siembra estimada',
        label: payload,
    }),
    'recomendation.climatePattern': (payload) => ({
        category: 'Recomendaciones (nueva)',
        action: 'Seleccionar año climático',
        label: payload,
    }),
    'recomendation.soilMoisture': (payload) => ({
        category: 'Recomendaciones (nueva)',
        action: 'Seleccionar agua en suelo',
        value: payload,
    }),
    'recomendation.soilType': (payload) => ({
        category: 'Recomendaciones (nueva)',
        action: 'Seleccionar tipo de suelo',
        label: payload,
    }),
    'recomendation.environment': (payload) => ({
        category: 'Recomendaciones (nueva)',
        action: 'Seleccionar ambiente',
        value: payload,
    }),
    'recomendation.previousCrop': (payload) => ({
        category: 'Recomendaciones (nueva)',
        action: 'Seleccionar cultivo antecesor',
        label: payload,
    }),
    'recomendation.chemicalFallow': (payload) => ({
        category: 'Recomendaciones (nueva)',
        action: 'Seleccionar barbecho químico',
        label: payload,
    }),
    'recomendation.weed': (payload) => ({
        category: 'Recomendaciones (nueva)',
        action: 'Seleccionar maleza',
        label: payload,
    }),
    'recomendation.viewStage': (payload) => ({
        category: `Recomendaciones (detalle: ${payload.type})`,
        action: 'Ver slide',
        label: payload.label,
    }),

    'fields.new': {
        category: 'Lotes (listado)',
        action: 'Nuevo',
    },
    'fields.expandNewRecomendation': {
        category: 'Lotes (listado)',
        action: 'Expandir nueva recomendación',
    },
    'fields.collapseNewRecomendation': {
        category: 'Lotes (listado)',
        action: 'Colapsar nueva recomendación',
    },

    'fields.create': {
        category: 'Lotes (nuevo)',
        action: 'Guardar (online)',
    },
    'fields.createOffline': {
        category: 'Lotes (nuevo)',
        action: 'Guardar (offline)',
    },
    'fields.coordinates': {
        category: 'Lotes (nuevo)',
        action: 'Geolocalizar coordenadas',
    },
    'fields.geolocate': (payload) => ({
        category: 'Lotes (nuevo)',
        action: 'Geolocalizar ubicación',
        label: payload.query,
    }),
    'fields.geolocateError': {
        category: 'Lotes (nuevo)',
        action: 'Error de geolocalización de ubicación',
    },
    'fields.geolocateDevice': {
        category: 'Lotes (nuevo)',
        action: 'Geolocalizar dispositivo',
    },
    'fields.geolocateDeviceError': {
        category: 'Lotes (nuevo)',
        action: 'Error de geolocalización de dispositivo',
    },
    'fields.drawPoint': {
        category: 'Lotes (nuevo)',
        action: 'Marcar punto',
    },
    'fields.acceptPoint': {
        category: 'Lotes (nuevo)',
        action: 'Aceptar punto',
    },
    'fields.savePoint': {
        category: 'Lotes (nuevo)',
        action: 'Guardar punto',
    },
    'fields.resetPoint': {
        category: 'Lotes (nuevo)',
        action: 'Resetear punto',
    },
    'fields.drawPolygon': {
        category: 'Lotes (nuevo)',
        action: 'Marcar polígono',
    },
    'fields.acceptPolygon': {
        category: 'Lotes (nuevo)',
        action: 'Aceptar polígono',
    },
    'fields.savePolygon': {
        category: 'Lotes (nuevo)',
        action: 'Guardar polígono',
    },
    'fields.resetPolygon': {
        category: 'Lotes (nuevo)',
        action: 'Resetear polígono',
    },
    'fields.cancelNaming': {
        category: 'Lotes (nuevo)',
        action: 'Cancelar ingreso de nombre',
    },
    'fields.delete': {
        category: 'Lotes (guardados)',
        action: 'Eliminar',
    },

    'cornComparator.expandProducts': {
        category: 'Comparador de productos (Maíz)',
        label: 'Expandir productos a comparar',
    },
    'cornComparator.collapseProducts': {
        category: 'Comparador de productos (Maíz)',
        label: 'Colapsar productos a comparar',
    },
    'cornComparator.updateProducts': (payload) => ({
        category: 'Comparador de productos (Maíz)',
        action: 'Modificar productos a comparar',
        value: payload.count,
    }),
    'soyComparator.expandProducts': {
        category: 'Comparador de productos (Soja)',
        label: 'Expandir productos a comparar',
    },
    'soyComparator.collapseProducts': {
        category: 'Comparador de productos (Soja)',
        label: 'Colapsar productos a comparar',
    },
    'soyComparator.updateProducts': (payload) => ({
        category: 'Comparador de productos (Soja)',
        action: 'Modificar productos a comparar',
        value: payload.count,
    }),

    'maps.corn.diseases.historicPressure': (payload) => ({
        category: 'Maíz - Enfermedades (Presión histórica)',
        action: 'Seleccionar mapa',
        label: payload.name,
    }),
    'maps.corn.pests.historicPressure': (payload) => ({
        category: 'Maíz - Plagas (Presión histórica)',
        action: 'Seleccionar mapa',
        label: payload.name,
    }),
    'maps.corn.pests.weeklyForecast': (payload) => ({
        category: 'Maíz - Plagas (Pronóstico semanal)',
        action: 'Seleccionar mapa',
        label: payload.name,
    }),
    'maps.corn.yield': (payload) => ({
        category: 'Maíz - Rendimiento',
        action: 'Seleccionar mapa',
        label: payload.name,
    }),
    'maps.corn.others': (payload) => ({
        category: 'Maíz - Otros mapas',
        action: 'Seleccionar mapa',
        label: payload.name,
    }),
    'maps.weeds.REM': (payload) => ({
        category: 'Malezas - Mapas REM',
        action: 'Seleccionar mapa',
        label: payload.name,
    }),
    'home.recommendation.corn': {
        category: 'Home',
        action: 'Ingreso a recomendación maíz',
    },
    'home.recommendation.soy': {
        category: 'Home',
        action: 'Ingreso a recomendación soja',
    },
    'home.cropProtection': {
        category: 'Home',
        action: 'Ingreso a recomendación de protección de cultivos',
    },
    'bagquality.bagquality': {
        category: 'Home',
        action: 'Ingreso a calidad de siembra',
    },
    'nitrogenrecommendation.nitrogenrecommendationlist.nitrogen': {
        category: 'Home',
        action: 'Ingreso a proyecto nitrógeno smart',
    },
    'home.h2h.corn': {
        category: 'Home',
        action: 'Ingreso a H2H maíz',
    },
    'home.h2h.soy': {
        category: 'Home',
        action: 'Ingreso a H2H soja',
    },
    'fieldtrialnetwork.fieldtrialnetwork': {
        category: 'Home',
        action: 'Ingreso a red de ensayos',
    },
    'home.weather': {
        category: 'Home',
        action: 'Ingreso a clima',
    },
    'catalog.brandselection.catalog': {
        category: 'Home',
        action: 'Ingreso a catálogos',
    },
    'library.librarylist.library': {
        category: 'Home',
        action: 'Ingreso a biblioteca',
    },
    'myrecommendations.my-recommendations': {
        category: 'Home',
        action: 'Ingreso a mis recomendaciones',
    },
    'home.weeds.corn': {
        category: 'Home',
        action: 'Ingreso a malezas',
    },
    'home.fielddetail': {
        category: 'Home',
        action: 'Ingreso a mis lotes',
    },
    'fields.newfield.fielddetail': {
        category: 'Home',
        action: 'Ingreso a nuevo lote',
    },
    'home.home': {
        category: 'Home',
        action: 'Volver a la home',
    },
    'map.maps': {
        category: 'Home',
        action: 'Ingreso a mapas',
    },
    'soymultipliers.multipliers': {
        category: 'Home',
        action: 'Ingreso a PTV multiplicadores de soja',
    },
    'home.carboncalculator': {
        category: 'Home',
        action: 'Ingreso a calculadora de carbono',
    },
    'home.deseasesPlaguesAndWeeds': {
        category: 'Home',
        action: 'Abrir enfermedades, plagas y malezas',
    },
    'cropmonitoring.cropmonitoring.cropmonitoring': {
        category: 'Home',
        action: 'Ingreso al seguimiento de cultivo (Maíz)',
    },
    'cropMonitoring.create.start': (payload) => ({
        category: `Seguimiento de cultivo (${payload.type === 'corn' ? 'Maíz' : 'Soja'})`,
        action: 'Click crear nuevo seguimiento',
        label: `Comenzó el formulario de creación (${payload.type === 'corn' ? 'Maíz' : 'Soja'})`,
    }),
    'cornCropMonitoring.create.finalize': (payload) => ({
        category: 'Seguimiento de cultivo (Maíz)',
        action: payload.source ? `Click crear seguimiento (${payload.source})` : 'Click crear seguimiento',
        label: payload.source ? `Finalizo la creación (Maíz) (${payload.source})` : 'Finalizo la creación (Maíz)',
    }),
    'cornCropMonitoring.detail': (payload) => ({
        category: 'Seguimiento de cultivo (Maíz)',
        action: 'Click ver detalle',
        value: payload.id,
    }),
    'cropMonitoring.detail.fromHome': (payload) => ({
        category: 'Seguimiento de cultivo (Maíz)',
        action: 'Click ver detalle desde Home',
        value: payload.id,
    }),
    'cornCropMonitoring.detail.back': {
        category: 'Seguimiento de cultivo (Maíz)',
        action: 'Click volver a mis seguimientos',
    },
    'cropMonitoring.createFrom-Modal': {
        category: 'Seguimiento de cultivo (Maíz)',
        action: 'Click en crear seguimiento desde modal de home',
    },
    'cornCropMonitoring.detail.cropProtectionSwitch': (payload) => ({
        category: 'Seguimiento de cultivo (Maíz)',
        action: `Switch toggle (${payload.state ? 'Abrir' : 'Cerrar'})`,
        label: 'Switch Crop Protection',
    }),
    'cropProtection.recommendation_start': {
        category: 'Crop Protection Recommendation',
        action: 'Ingreso a recomendación de protección de cultivos',
    },
    'bag-quality.search-success': ({ payload }: { payload: { search: string; brand: string } }) => ({
        category: 'Corn Bag Quality',
        action: 'Éxito al buscar información de bolsa',
        value: `${payload.search}-${payload.brand}`,
    }),
    'bag-quality.search-error': ({ payload }: { payload: { search: string; brand: string } }) => ({
        category: 'Corn Bag Quality',
        action: 'Error al buscar información de bolsa',
        value: `${payload.search}-${payload.brand}`,
    }),
    /** @param {{categories:Array<string>}} payload */
    'library.list.filters': (payload) => ({
        category: 'Filtros de biblioteca',
        action: 'Filtro seleccionado',
        label: payload.categories.join(', '),
    }),
    /** @param {{type:'sidebar' | 'overlay'}} payload */
    'maps.spodoptera_forecast': (payload) => ({
        category: 'Pronóstico de Spodoptera',
        action: `Click en ${payload.type} pronóstico de spodoptera`,
    }),
    'askanexpert.open': {
        category: 'Ask an expert',
        action: 'Click en consulta a un experto',
    },
    'terms.open': {
        category: 'Terms',
        action: 'Click términos y condiciones',
    },
    'privacy.open': {
        category: 'Privacy',
        action: 'Click Política de Privacidad',
    },
    'notifications.iconClick': {
        category: 'Notificaciones',
        action: 'Click icon',
    },
    /** @param {{type?: 'all'}} payload */
    'notifications.markAsRead': (payload) => ({
        category: 'Notificaciones',
        action: payload.type === 'all' ? 'Marcar todo como leído' : 'Marcar como leída',
    }),
    'notifications.viewAll': {
        category: 'Notificaciones',
        action: 'Ver todas las notificaciones',
    },
    /** @param {{open?: boolean}} payload */
    'notifications.vtPro4': (payload) => ({
        category: 'Notificaciones',
        action: payload.open ? 'Abrir alerta VTPro4' : 'Cerrar alerta VTPro4',
    }),
    'cropMonitoring.open': {
        category: 'Notificaciones',
        action: 'Ir al seguimiento de lote',
    },
    'frost_risk.frost_risk': {
        category: 'Home',
        action: 'Ingreso a Riesgo de helada',
    },
    'frost_risk.frost_risk.forecast': {
        category: 'Riesgo de helada',
        action: 'Ingreso a riesgo de heladas para los próximos días',
    },
    'frost_risk.frost_risk_map.GDU_7': {
        category: 'Riesgo de helada',
        action: 'Ingreso al pronóstico de riesgo de helada GDUs acumulados a 7 días',
    },
    'frost_risk.frost_risk_map.GDU_14': {
        category: 'Riesgo de helada',
        action: 'Ingreso al pronóstico de riesgo de helada GDUs acumulados a 14 días',
    },
    'frost_risk.frost_risk_map.minimal_temp': {
        category: 'Riesgo de helada',
        action: 'Ingreso al pronóstico de riesgo de helada temperaturas mínimas',
    },
};

export default events;
